<template>
  <div class="section-project_list">
    <div class="row">
      <div class="col-4" :class="[{ 'is--empty':!project.img }]" v-for="(project, index) in projects" :key="index">
        <div :class="['section-project_listItem', { 'is--ended':project.projectEnded }]">
          <template v-if="project.link">
            <a :href="project.link" target="_blank">
              <img :src="`/static/img/${project.img}`" :alt="project.title" v-if="project.img"/>
            </a>
          </template>
          <template v-else>
            <img :src="`/static/img/${project.img}`" :alt="project.title" v-if="project.img"/>
          </template>
          <h4>{{ project.title }}</h4>
          <p class="text--description" v-html="project.description"></p>
          <p class="text--date">
            {{ project.dateStart | moment('YYYY.MM.DD') }}
            <template v-if="project.dateEnd === 'now'"> 〜 現在に至る</template>
            <template v-else-if="project.dateEnd"> 〜 {{ project.dateEnd | moment('YYYY.MM.DD') }}</template>
          </p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    onlyIndex: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    projects() {
      return this.$store.getters.getProjects.filter((x) => {
        if(this.onlyIndex) {
          return x.index === true;
        }
        return true;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/common/Projects.vue